'use strict';

var _videoPlayer = require('./video-player/video-player');

var _videoPlayer2 = _interopRequireDefault(_videoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _videoPlayer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/video-player-react/dist/src/index.js
// module id = 1562
// module chunks = 1 2 3